import React from "react";



const RowTable = (props) => {


  const {
   idFurgon,
    placa_furgon,
    chasis_cabezal,
    marca,
    modelo, 
    id_empresa_trans
  
  } = props.furgon;
  const { indice } = props;

  return (
    <tr>
      <th scope="row">{indice + 1}</th>
      {idFurgon && <td>{idFurgon}</td>}
    
      <td>
    {placa_furgon}
      </td>
      <td>
        {chasis_cabezal}
      </td>
      <td>
        {marca}
      </td>
      <td>
        {modelo}
      </td>
      <td>
        {id_empresa_trans}
      </td>
    </tr>
  );
};

export default RowTable;
